var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMovements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.63998L3.4 4.01998C3.2 3.95998 3 4.10998 3 4.31998V15.68C3 15.89 3.2 16.04 3.4 15.98L5.49 15.35C5.62 15.31 5.71 15.19 5.71 15.05V4.93998C5.71 4.79998 5.62 4.67998 5.49 4.63998H5.5Z",
    fill: "url(#paint0_linear_23_646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72998 17.69V2.30999C7.72998 2.06999 7.97998 1.91999 8.18998 2.02999L10.87 3.42999C10.97 3.47999 11.04 3.58999 11.04 3.70999V16.28C11.04 16.4 10.98 16.5 10.87 16.56L8.18998 17.96C7.97998 18.07 7.72998 17.92 7.72998 17.68V17.69Z",
    fill: "url(#paint1_linear_23_646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.51 3.22999V16.77C13.51 17.03 13.81 17.18 14.01 17.02L16.8 14.94C16.88 14.88 16.93 14.79 16.93 14.69V5.30999C16.93 5.20999 16.88 5.11999 16.8 5.05999L14.01 2.97999C13.8 2.81999 13.51 2.97999 13.51 3.22999Z",
    fill: "url(#paint2_linear_23_646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_646",
    x1: 3,
    y1: 9.99998,
    x2: 5.72,
    y2: 9.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222648"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_646",
    x1: 9.37998,
    y1: 3.78999,
    x2: 9.37998,
    y2: 16.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_646",
    x1: 16.93,
    y1: 9.99999,
    x2: 13.51,
    y2: 9.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.93,
    height: 16,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMovements);
export default __webpack_public_path__ + "static/media/ico-movements.0fd02557bdf16dd53fd6e37592f4493d.svg";
export { ForwardRef as ReactComponent };